import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Intermediary page to ensure cookies are set before final redirect
 * This helps Safari properly persist session cookies during OAuth flow
 * Research: https://community.auth0.com/t/authentication-broken-on-asp-net-core-and-safari-on-ios-12-mojave-take-2/19104
 */
export default function AuthSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    // Wait a brief moment to ensure cookie is set in Safari
    const timer = setTimeout(() => {
      console.log('Auth success - redirecting to dashboard');
      navigate('/dashboard', { replace: true });
    }, 300); // 300ms delay to ensure cookie persistence

    return () => clearTimeout(timer);
  }, [navigate]); // Added navigate dependency

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-emerald-100">
      <div className="text-center bg-white rounded-2xl shadow-xl p-8 max-w-md">
        <div className="mb-4">
          <svg 
            className="w-16 h-16 text-green-600 mx-auto" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Authentication Successful! ✅
        </h1>
        <p className="text-gray-600 mb-4">
          Redirecting to your dashboard...
        </p>
        <div className="animate-pulse">
          <div className="h-2 bg-green-600 rounded-full w-3/4 mx-auto"></div>
        </div>
      </div>
    </div>
  );
}
